import React from 'react';

import PropTypes from 'prop-types';
import './FlipButton.scss';

export default class FlipButton extends React.Component {

  constructor(props) {
    super(props);

    FlipButton.propTypes = {
      /** Called on clicking the button */
      handleClick: PropTypes.func,
      /** Text displayed on the front of the button */
      frontText: PropTypes.string,
      /** Text displayed on the back of the button */
      backText: PropTypes.string,
    };
    this.state = {
      clicked: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick() {
    this.setState({ clicked: true });
    this.props.handleClick();
  }

  render() {
    const { frontText, backText } = this.props;
    const clicked = this.state.clicked;
    let buttonContainerClass = 'flip-button-container';
    if(clicked) {
      //flip the accept button and hide the 'no thanks' button
      buttonContainerClass = 'flip-button-container flip-button-container--flipped';
    }
    return (
      <div className={buttonContainerClass}>
        <div className="flip-button-container__flipper">
          <button className="flip-button-container__button flip-button flip-button--front" onClick={this.handleClick}>{frontText}</button>
          <button className="flip-button-container__button flip-button flip-button--back" >{backText}</button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/FlipButton/index.js